var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useLayoutEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { v4 as uuidv4 } from 'uuid';
import { get } from '../..';
import Caption from './Caption';
import Card from './Card';
import EmptyCard from './EmptyCard';
import { getBoxShadow } from '../shared';
var StyledTableCardList = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  && {\n    border: 1px solid ", ";\n    background-color: ", ";\n  }\n\n  ", "\n"], ["\n  && {\n    border: 1px solid ", ";\n    background-color: ", ";\n  }\n\n  ", "\n"])), get.colors('grey-80'), get.colors('white'), function (_a) {
    var container = _a.container;
    return container ? getBoxShadow() : css(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
});
var TableCardListRefForwardingComponent = function (_a, ref) {
    var _b = _a.tableInstance, preExpandedRows = _b.preExpandedRows, prepareRow = _b.prepareRow, headerGroups = _b.headerGroups, className = _a.className, container = _a.container, captionText = _a.captionText, _c = _a.isCaptionVisible, isCaptionVisible = _c === void 0 ? false : _c, mdDownHeaderDetail = _a.mdDownHeaderDetail, rowToFocus = _a.rowToFocus, isLoading = _a.isLoading, cardDataProps = __rest(_a, ["tableInstance", "className", "container", "captionText", "isCaptionVisible", "mdDownHeaderDetail", "rowToFocus", "isLoading"]);
    var _d = __read(useState(''), 2), tableId = _d[0], setTableId = _d[1];
    /*
     * Generate a unique id for the table before it is painted in the DOM. This id
     * ties the table to the Caption component since it isn't a true <table> with
     * a <caption>
     */
    useLayoutEffect(function () {
        setTableId(uuidv4());
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Caption, __assign({}, { captionText: captionText, isCaptionVisible: isCaptionVisible, tableId: tableId })),
        React.createElement(StyledTableCardList, { className: className, container: container, "aria-labelledby": tableId, ref: ref, tabIndex: -1 }, preExpandedRows.length ? (preExpandedRows.map(function (row, index) {
            prepareRow(row);
            var cardIsFocused = rowToFocus === index;
            return (React.createElement(Card, __assign({ key: row.id, row: row, mdDownHeaderDetail: mdDownHeaderDetail, cardIsFocused: cardIsFocused, isLoading: isLoading, index: index }, cardDataProps)));
        })) : (React.createElement(EmptyCard, { headerGroups: headerGroups, isLoading: isLoading })))));
};
var TableCardList = React.forwardRef(TableCardListRefForwardingComponent);
export default TableCardList;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map